<template>
  <div class="product-wrapper">
    <div class="banner-container">
      <div class="banner-item">
        <img class="bg" src="../../assets/images/banner-bg.png"/>
        <div class="content">
          <div class="title">产品与服务</div>
          <div class="title">智慧医疗分诊排队叫号系统</div>
          <div class="subtitle"></div>
          <div class="desc">
            还在为这些问题而烦恼吗？
            <br/>
           医院排队挂号太慢；医生叫号太累；护士维护排号秩序太难；病人排队不自觉；
            <br/>
            智慧医疗分诊排队叫号系统为您提供一站式解决方案！
          </div>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="content content-about">
            <div class="about-left">
              <div class="image-single">
                <!-- <img src="../../assets/images/hqms/hqms-1.png" style="width: 85%;"/> -->
              </div>
            </div>
            <div class="about-right">
              <div class="about-title" style="text-align:center;">智慧医疗分诊排队叫号系统</div>
              <div class="about-desc" style="margin-left:111px">
                患者挂号之后，直接进入候诊队列或者通过签到机，护士分诊台签到进入候诊队列
                <br/>
               医生在电脑上进行通过叫号程序呼叫病人，护士可以通过护士站程序来维护病人排队队列通过分诊排队系统可以实现病人自觉排队看病，提高医院看病效率，维护医院秩序，加快建设的目标医院信息化。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">分诊排队叫号系统签到机</div>
            <div class="subtitle">
                支持多种签到（刷健康卡，医保卡，身份证）
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/hqms/hqms-2.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">诊区大屏和诊间小屏</div>
            <div class="subtitle">
                支持显示界面定制
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/hqms/hqms-3.png" style="float:left;width:69%;height:450px;margin-right:3%;"/>
                <img src="../../assets/images/hqms/hqms-5.jpg" style="width:28%;height:450px;"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">医生叫号客户端</div>
            <div class="subtitle">
                可重呼，可过号,支持顺呼和选叫
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/hqms/hqms-1.png" style="float:left;width:45%;height:560px;margin-right:10%;"/>
                <img src="../../assets/images/hqms/hqms-6.png" style="width:45%;height:560px;"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">护士分诊台</div>
            <div class="subtitle">
                支持对病人排队顺序进行调整,
                <br/>
                支持人工签到,支持人工转移病人的科室队列
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/hqms/hqms-4.png" style="height:450px;"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="title">分诊排队叫号系统优势</div>
          <div class="content content-box">
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/hqms/merit-1.png"/>
                <div class="box-title">签到</div>
                <div class="box-desc">
                  1、支持签到策略配置<br/>
                  2、不签到；<br/>
                  3、初诊签到；<br/>
                  4、复诊签到以及过号签到；<br/>
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/hqms/merit-2.png"/>
                <div class="box-title">叫号</div>
                <div class="box-desc">
                  1、支持叫号策略<br/>
                  2、签到病人叫号策略；<br/>
                  3、复诊叫号策略；<br/>
                  4、过号患者的叫号策略；<br/>
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/hqms/merit-3.png"/>
                <div class="box-title">展示</div>
                <div class="box-desc">
                  1、支持单科室多医生叫号策略；<br/>
                  2、单屏显示多医生信息；<br/>
                  3、支持单医生多科室叫号策略；<br/>
                  4、单医生显示多科室排队信息；
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/hqms/merit-4.png"/>
                <div class="box-title">其他</div>
                <div class="box-desc">
                  1、支持病人转移科室；<br/>
                  2、支持体检病人拉入科室排队队列；<br/>
                  3、支持医生信息自定义维护；<br/>
                  4、支持诊间屏空闲时间轮播医院宣教；
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .body-container {}
  .nav-container {
    width: @width-max;
    margin: 0 auto;
    padding: 26px 0;
    display: flex;
    align-items: center;
    .nava {
      padding: 15px;
      font-size: 16px;
      flex: 1;
      text-align: center;
    }
  }
  .intro-container .intro-con .content.content-box .box-con .box-item {
      height: 240px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/product2.vue